import * as React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { LucideIcon } from 'utils/lucideIcon'
import './styles.scss'

// Views opened from global search carry the interpreted scope in this query
// param (human-readable, e.g. "Visiting today · Cancelled"). List pages
// render it through this badge so the user sees the page is not showing its
// default view — and can leave it with one click.
export const VIA_SEARCH_PARAM = 'viaSearch'

interface SearchScopeBadgeProps {
    // Query params the page's default view keeps (e.g. memberships' `tab`).
    keepParams?: string[]
}

export const SearchScopeBadge = ({ keepParams = [] }: SearchScopeBadgeProps): JSX.Element | null => {
    const history = useHistory()
    const location = useLocation()
    const params = new URLSearchParams(location.search)
    const label = params.get(VIA_SEARCH_PARAM)

    if (!label) {
        return null
    }

    const showDefaultView = () => {
        const kept = new URLSearchParams()
        keepParams.forEach((key) => {
            const value = params.get(key)
            if (value !== null) {
                kept.set(key, value)
            }
        })
        history.replace({ pathname: location.pathname, search: kept.toString() })
    }

    return (
        <div className="search-scope-badge" title="Applied by your search">
            <LucideIcon iconName="Search" size={13} />
            <span className="search-scope-badge-label">{label}</span>
            <button
                type="button"
                className="search-scope-badge-clear"
                onClick={showDefaultView}
                aria-label="Remove search filters and show the default view"
                title="Back to the default view"
            >
                <LucideIcon iconName="X" size={13} />
            </button>
        </div>
    )
}
